import { SafeHtml } from "@angular/platform-browser";

export interface BaseDialogData {
  title?: string | SafeHtml;
  actions?: BaseDialogActionData[];
}

export interface BaseDialogActionData {
  actionKey: string | CommonActionKey;
  label: string;
  buttonColor: ButtonColor;
  initialFocus?: boolean;
}

export enum ButtonColor {
  Primary = "primary",
  Default = "",
}

export enum CommonActionKey {
  Cancel = "cancel",
  Confirm = "confirm",
  Continue = "continue",
  Discard = "discard",
  GoToDashboard = "goToDashboard",
  No = "no",
  Ok = "ok",
  Save = "save",
  TryAgain = "tryAgain",
  Yes = "yes"
}
